import React, { FC } from 'react';
import { Grid } from '@material-ui/core';

import { ContentFragment } from 'api';
import { GridLayoutSizes } from 'types/app';

import GridResult from './GridResult';

interface Props {
  results: ContentFragment[];
  indexes: number[];
}

export const LargeSection: FC<Props> = ({ indexes, results }) => {
  return (
    <Grid container>
      <Grid item xs>
        <GridResult result={results[indexes[0]]} variant={GridLayoutSizes.Large} />
      </Grid>
    </Grid>
  );
};

export const MediumSection: FC<Props> = ({ indexes, results }) => {
  return (
    <Grid container spacing={5}>
      <Grid item xs={12} md={6}>
        <GridResult result={results[indexes[0]]} variant={GridLayoutSizes.Medium} />
      </Grid>
      <Grid item xs={12} md={6}>
        <GridResult result={results[indexes[1]]} variant={GridLayoutSizes.Medium} />
      </Grid>
    </Grid>
  );
};

export const SmallSection: FC<Props> = ({ indexes, results }) => {
  return (
    <Grid container spacing={5}>
      <Grid item xs={12} md={4}>
        <GridResult result={results[indexes[0]]} variant={GridLayoutSizes.Small} />
      </Grid>
      <Grid item xs={12} md={4}>
        <GridResult result={results[indexes[1]]} variant={GridLayoutSizes.Small} />
      </Grid>
      <Grid item xs={12} md={4}>
        <GridResult result={results[indexes[2]]} variant={GridLayoutSizes.Small} />
      </Grid>
    </Grid>
  );
};

export const VerticalSection: FC<Props> = ({ indexes, results }) => {
  return (
    <Grid container direction="column" spacing={3}>
      <Grid item xs>
        <GridResult result={results[indexes[0]]} variant={GridLayoutSizes.Mini} />
      </Grid>
      <Grid item xs>
        <GridResult result={results[indexes[1]]} variant={GridLayoutSizes.Mini} />
      </Grid>
      <Grid item xs>
        <GridResult result={results[indexes[2]]} variant={GridLayoutSizes.Mini} />
      </Grid>
    </Grid>
  );
};
